export function filterInboxResults() {
  var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var section = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;


  // app

  if (section === "app" && value) {

    return results.filter(function (item) {
      return item['appName'] === value;
    });
  } else if (section === "app") {

    return results.filter(function (item) {
      return typeof item['appName'] !== 'undefined';
    });
  }

  // type

  if (section === "type" && value) {

    return results.filter(function (item) {
      return item['inboxType'] === value;
    });
  } else if (section === "type") {

    return results.filter(function (item) {
      return typeof item['inboxType'] !== 'undefined';
    });
  }

  // owner

  if (section === "owner" && value) {

    return results.filter(function (item) {
      return item['ownerName'] === value;
    });
  } else if (section === "owner") {

    return results.filter(function (item) {
      return typeof item['ownerName'] !== 'undefined';
    });
  }
}